import { createNotImplementedMethod } from '../utils';
var NotImplementedNotificationsRepository = /** @class */ (function () {
    function NotImplementedNotificationsRepository() {
        this.getNotifications = createNotImplementedMethod();
        this.setSeenNotification = createNotImplementedMethod();
    }
    return NotImplementedNotificationsRepository;
}());
export { NotImplementedNotificationsRepository };
